import React from 'react';
import {
	ClientSymbol,
	ClientText,
	Main,
	MedianSymbol,
	MedianText,
	Sub,
} from './ChartLegend.styles';

const ChartLegend = () => {
	return (
		<Main>
			<Sub>
				<ClientText>Total &nbsp;</ClientText>
				<ClientSymbol />

				<ClientText>{`Direct`} &nbsp;</ClientText>
				<ClientSymbol style={{ borderBottomColor: '#a52a2a' }} />

				<ClientText>{`Indirect`} &nbsp;</ClientText>
				<ClientSymbol style={{ borderBottomColor: '#6495ed' }} />
			</Sub>
			<Sub>
				<MedianText>Median</MedianText>
				<MedianSymbol />
			</Sub>
		</Main>
	);
};

export default ChartLegend;
